<mbs-sidepanel
  id="reseller-notifications-sidepanel"
  innerContentType="inner"
  side="right"
  [headerClass]="'-light'"
  [show]="notificationsService.isPanelOpen()"
  [showFooter]="false"
  (panelClosed)="notificationsService.closePanel()">
  <div
    class="mbs-sidepanel_title"
    header-title>
    <div class="mbs-sidepanel_title-name">{{ 'notifications.title' | i18next }}</div>
  </div>

  <div
    class="reseller-notification-toolbar"
    header-content>
    <mbs-switcher
      data-e2e="notifications-mute-switcher"
      [id]="'notifications-muted-switcher'"
      [label]="'notifications.showNotifications' | i18next"
      [name]="'notificationsMuted'"
      [selected]="!notificationsService.muted()"
      [showStatus]="false"
      (change)="handleMutedChange($event)" />

    @if (notifications().length) {
      <mbs-button
        data-e2e="notifications-clear-all-button"
        [isCtrl]="true"
        (click)="notificationsService.clearAll()">
        {{ 'notifications.clearAll' | i18next }}
      </mbs-button>
    }
  </div>

  <ng-container body>
    @if (notifications().length) {
      <ul
        class="reseller-notification-list"
        data-e2e="notification-list">
        @for (notification of notifications(); track notification.id) {
          @let title = titleOf(notification);

          <li
            class="reseller-notification-item"
            data-e2e="notification-list-item">
            <div class="reseller-notification-head">
              <span
                class="reseller-notification-ico"
                data-e2e="notification-icon"
                [ngClass]="getIconClasses(notification)"></span>

              <span class="reseller-notification-date text-muted">{{ notification.date | date: 'short' }}</span>

              <mbs-button
                data-e2e="notification-remove-button"
                icon="fa fa-trash-o"
                [isCtrl]="true"
                [type]="'dark'"
                (click)="notificationsService.remove(notification.id)" />
            </div>

            @if (title) {
              <div class="reseller-notification-title">{{ title }}</div>
            }

            <div
              class="reseller-notification-message"
              data-e2e="notification-message">
              {{ messageOf(notification) }}
            </div>

            @if (isLong(notification)) {
              <mbs-button
                data-e2e="notification-details-button"
                [isCtrl]="true"
                (click)="showDetails(notification)">
                {{ 'notifications.showMore' | i18next }}
              </mbs-button>
            }
          </li>
        }
      </ul>
    } @else {
      <div
        class="text-muted text-center"
        data-e2e="notification-list-empty">
        {{ 'notifications.empty' | i18next }}
      </div>
    }
  </ng-container>
</mbs-sidepanel>

<ng-template #detailsTemplate>
  <div class="reseller-notification-details text-break">{{ messageOf(selectedNotification()) }}</div>
</ng-template>
